import { BinsoObject, ServiceObject } from "@/types/parlor";

interface ParlorPriceTableProps {
  companyName: string;
  binsos: BinsoObject[];
  services: ServiceObject;
}

const MAX_CHARGE_LABEL = "최고가";

export const ParlorPriceTable = ({
  companyName,
  binsos,
  services,
}: ParlorPriceTableProps) => {
  if (binsos.length === 0) return null;

  const maxCharge = Math.max(...binsos.map((b) => b.charge));
  const currentYear = new Date().getFullYear();

  const serviceEntries = Object.entries(services).filter(
    ([, v]) => v.charge > 0
  );

  return (
    <section
      className="pd-section"
      id="pd-pricing"
      aria-labelledby="pd-price-title"
    >
      <header className="pd-section__head">
        <div className="pd-section__title-block">
          <span className="pd-section__eyebrow">시설 사용료</span>
          <h2 id="pd-price-title">빈소 및 안치실 이용요금</h2>
          <p className="pd-section__desc">
            {companyName} 시설의 1일 기준 이용요금입니다. 인력·용품·차량 비용은
            별도이며, 전체 견적은 고이장례연구소에서 무료로 안내해 드립니다.
          </p>
        </div>
      </header>

      <div
        className="pd-price-wrap"
        role="region"
        aria-labelledby="pd-price-title"
      >
        <table className="pd-price-table">
          <caption>{companyName} 시설 이용요금표 · 단위: 1일 기준</caption>
          <thead>
            <tr>
              <th scope="col">구분</th>
              <th scope="col">시설명</th>
              <th scope="col" style={{ textAlign: "right" }}>
                요금
              </th>
              <th scope="col">단위</th>
            </tr>
          </thead>
          <tbody>
            {binsos.map((binso, i) => (
              <tr
                key={i}
                className={binso.charge === maxCharge ? "pd-highest" : ""}
              >
                <td>
                  <span className="pd-pt-cat">
                    {binso.charge === maxCharge ? MAX_CHARGE_LABEL : "빈소"}
                  </span>
                </td>
                <td className="pd-pt-name">{binso.item}</td>
                <td style={{ textAlign: "right" }}>
                  <span className="pd-pt-price">
                    {binso.charge.toLocaleString()}
                  </span>
                  <span className="pd-pt-unit">원</span>
                </td>
                <td className="pd-pt-unit">1일</td>
              </tr>
            ))}
            {serviceEntries.map(([name, val]) => (
              <tr key={name}>
                <td>
                  <span className="pd-pt-cat">서비스</span>
                </td>
                <td className="pd-pt-name">{name}</td>
                <td style={{ textAlign: "right" }}>
                  <span className="pd-pt-price">
                    {val.charge.toLocaleString()}
                  </span>
                  <span className="pd-pt-unit">원</span>
                </td>
                <td className="pd-pt-unit">1회</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="pd-price-foot">
          <span>
            ※ 표시된 요금은 시설·서비스 사용료이며, 인력·차량·용품·음식 비용은
            별도입니다.
          </span>
          <span>출처: e하늘 장사정보시스템 ({currentYear}년 기준)</span>
        </div>
      </div>
    </section>
  );
};
